var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_110208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 50.6671C10.6663 54.6671 10.6663 44.0005 5.33301 42.6672M42.6663 58.6671V48.3471C42.7664 47.0756 42.5946 45.7973 42.1624 44.5973C41.7302 43.3972 41.0475 42.3029 40.1597 41.3872C48.533 40.4538 57.333 37.2805 57.333 22.7205C57.3323 18.9974 55.9002 15.417 53.333 12.7205C54.5486 9.46317 54.4627 5.86275 53.093 2.66715C53.093 2.66715 49.9463 1.73382 42.6663 6.61382C36.5544 4.95734 30.1117 4.95734 23.9997 6.61382C16.7197 1.73382 13.573 2.66715 13.573 2.66715C12.2033 5.86275 12.1174 9.46317 13.333 12.7205C10.7467 15.437 9.31307 19.0497 9.33301 22.8005C9.33301 37.2538 18.133 40.4272 26.5063 41.4672C25.629 42.3737 24.9524 43.4549 24.5205 44.6403C24.0886 45.8256 23.9112 47.0887 23.9997 48.3471V58.6671",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_110208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.b5f0b7214f1782f62c2414a7bb01209d.svg";
export { ForwardRef as ReactComponent };